<section
  class="info-content"
  [class.info-content--info]="type() === 'info'"
  [class.info-content--warning]="type() === 'warning'"
  [class.info-content--error]="type() === 'error'"
  [class.info-content--success]="type() === 'success'"
>
  @if (showIcon()) {
    <img
      src="assets/icons/icc_email.svg"
      width="20"
      height="20"
      alt=""
      class="info-content__icon mt-1"
    />
  }
  <p
    [class.t-13-500-dark]="type() === 'info'"
    [class.t-14-400-dark]="type() !== 'info'"
  >
    {{ messageType() }}
  </p>
</section>
